var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-hover-menu',{staticClass:"overline mx-2",scopedSlots:_vm._u([{key:"activator",fn:function(){return [_c('v-btn',{attrs:{"small":"","icon":""}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("warning")])],1)]},proxy:true}])},[_c('v-row',{staticClass:"mx-0 caption"},[_vm._v(" (Hiding "+_vm._s(_vm.hidden)+" contacts. No email.) ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }